import { Tag } from 'primereact/tag';

export const RequestStatus = ({ status }: any) => {
    let useStatusText: string = 'Ausstehend';
    let useStatusSeverity: any = 'warning';

    if (status === 'approved') {
        useStatusText = 'Genehmigt';
        useStatusSeverity = 'success';
    } else if (status === 'rejected') {
        useStatusText = 'Abgelehnt';
        useStatusSeverity = 'danger';
    }

    return (
        <Tag
            value={useStatusText}
            severity={useStatusSeverity}
        ></Tag>
    );
};
